import styled from 'styled-components'
import Media from 'builder/styles/media'

export const Container = styled.div`
  overflow: hidden;
  gap: 4px;
  display: flex;
  flex-direction: column;
`

export const Row = styled.div`
  display: flex;
  gap: 4px;

  ${Media.Phone`
    grid-template-columns: repeat(2, 1fr); 
    background: unset;
    gap: 4px;  
    display: grid;
  `}
`

export const Paywall = styled.div<{ $position: 'absolute' | 'unset' }>`
  background: url(${require('builder/views/Interview/view/FeedbackView/assets/paywall-bg2.png')})
    center/cover;
  border-radius: 20px;
  height: 184px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  position: ${({ $position }) => $position};
  bottom: 0;

  ${Media.Phone`
    height: 296px; 
  `}
`

export const BlurredImageCard = styled.img`
  flex: 1 1 0px;
  max-height: 184px;

  ${Media.Phone`
    max-height: 148px;
    `}
`

export const PaywallText = styled.div`
  width: 25%;
  text-align: center;
`
